import type { App } from 'vue';
import { createPinia } from 'pinia';

import getAppModules from '@modules/core/app/utils/getAppModules';
import registerSentry from '@modules/core/app/utils/registerSentry';
import AppModulePlugin from '@modules/core/plugins/AppModulePlugin';
import AppPermissionsPlugin from '@modules/core/plugins/AppPermissionsPlugin';
import { isLocalEnv } from '@modules/core/services/env-config/utils/envConfig';
import createAppRouter from '@modules/core/services/router/createAppRouter';
import { useTranslationsMapper } from '@modules/i18n/composables';
import { useAppMenu } from '@modules/sidebar/composables';
import {
  VueQueryPlugin,
} from '@tanstack/vue-query';

import getQueryClient from './getQueryClient';
import registerPluginI18next from './registerPluginI18next';
import registerPluginPrimeVue from './registerPluginPrimeVue';

export default async function registerPlugins(app: App): Promise<void> {
  const queryClient = getQueryClient();

  app.use(createPinia());
  app.use(VueQueryPlugin, { queryClient });
  registerPluginPrimeVue(app);
  registerPluginI18next(app);

  const router = createAppRouter();

  if (!isLocalEnv() && !window.location.host.includes('development.local.io')) {
    await registerSentry(app, router);
  }

  app.use(AppModulePlugin, {
    router,
    modules: getAppModules(),
    menu: useAppMenu(),
    translationsMapper: useTranslationsMapper(),
  });
  app.use(AppPermissionsPlugin);
}
